var recently_viewed = (function() {
    const rv_key = 'recently_viewed';
    
    getNodes = (selector) => {
      return document.querySelectorAll(selector);
    }
    
    getProductJsonOLD = (handle) => {
      var url = `/products/${handle}.js`;
      return $.getJSON(url);
    }
    
    getProductJson = (handle) => {
      var url = `/products/${handle}.js`;
      return new Promise((resolve, reject) => {
        $.getJSON(url)
        .done(function(response) {
          //console.log(response)
          resolve(response);
        })
        .fail(function(error) {
          //console.error(error);
          resolve({});
        })
      });
    }  
    
    getProductData = () => {
      return new Promise((resolve, reject) => {
        var product_json = product_data || null;
        if (!product_json) {
          // TODO: FETCH PRODUCT DATA
        }
        else {
          resolve(product_json);
        }
      });
    }
    
    get_items_RV = () => {
      return (JSON.parse(localStorage.getItem(rv_key)) || []).reverse();
    }
    
    add_item_RV = (product) => {
      var recently_viewed_items = get_items_RV();
      
      var isNewItem = recently_viewed_items.filter(item => item.id == product.id).length == 0;
      if (isNewItem) {
        recently_viewed_items.push(product);
      }
      
      localStorage.setItem(rv_key, JSON.stringify(recently_viewed_items));
    }
    
    remove_item_RV = (handle) => {
      var recently_viewed_items = get_items_RV();
      recently_viewed_items = recently_viewed_items.filter(item => item.handle !== handle);
      localStorage.setItem(rv_key, JSON.stringify(recently_viewed_items));
    }  
    
    clear_items_RV = () => {
      localStorage.setItem(rv_key, null);
    }
    
    priceFormat = (value) => {
      var currency = Number(value / 100).toFixed(2);
      return '$' + currency;
    }  
    
    
    // Filter for showing price in USD
    Vue.filter('toUSD', function (value) {
      var currency = Number(value).toFixed(2);
      return '$' + currency;
    });  
    
    // Header
    var vm_recently_vw_header = new Vue({
      el: '#recently-viewed-header',
      
      data: {
        items: [],
        hideList: true,
        headerShowItems: 5
      },
      
      watch: {
        hideList: function(hideList) {
          document.body.classList.toggle('rv-list-active', !hideList);
        }
      },
      
      computed: {
        items_count: function() {
          return this.items.length;
        }
      },
      
      mounted: function() {
        var vm = this;
        vm.updateItems();
        vm.initEventHandlers();
      },
      
      methods: {
        updateItems: function() {
          var vm = this;
          var items = get_items_RV();
          vm.$set(vm, 'items', items);
        },
        
        initEventHandlers: function() {
          var vm = this;
          
          document.addEventListener('update:recently-viewed', function(e) {
            vm.updateItems();
          });
          
          var isProductViewed = getNodes('.template-product').length !== 0;
          if (isProductViewed) {
            getProductData()
            .then(product_json => {
              var selected_variant = product_json.variants.find(v => v.available) || product_json.variants[0];
              var product_tags = product_json.tags.join('--').toLowerCase();
              var show_price = product_tags.indexOf('enquire') == -1 && product_tags.indexOf('noprice') == -1;
              var product = {
                title: product_json.title,
                id: product_json.id,
                handle: product_json.handle,
                image_url: product_json.featured_image,
                price: selected_variant.price,
                price_compare: selected_variant.compare_at_price,
                show_price: show_price
              };
              //console.log(product);
              add_item_RV(product);
              document.dispatchEvent(new CustomEvent('update:recently-viewed'));
            });
          }
        },
        
        showProductsList: function(e) {
          var vm = this;
          vm.$el.querySelector('.recently-viewed-list').classList.toggle('dn');
        },
        
        toggleProductsList: function(e) {        
          var isMobile = window.matchMedia( "(max-width: 1000px)" ).matches;
          if (isMobile) {
            window.location.href = '/pages/recently-viewed';
          }
          else {
            this.hideList = !this.hideList;          
          }
        },
        
        clearItems: function(e) {
          clear_items_RV();
          document.dispatchEvent(new CustomEvent('update:recently-viewed'));
        }
      }
    });
  
    // Standalone page
    var vm_recently_vw = new Vue({
      el: '#recently-viewed-page',
      
      data: {
        items: [],
        products: []
      },
      
      computed: {
        c_products: function() {
          return this.products.map(p => {
            p.link = `/products/${p.handle}`;
            
            p.image_link = p.images[0];
            
            p.price = p.price / 100;
            p.list_price = p.compare_at_price / 100;
            
            //console.log(p);
            
            return p;
          });
        }
      },
      
      watch: {
        c_products: function(products) {
          document.dispatchEvent(new CustomEvent('recently-viewed-updated'));
        }
      },
      
      mounted: function() {
        var vm = this;
        vm.updateItems();
        
        document.addEventListener('update:recently-viewed', function(e) {
          //console.log(e);
          vm.updateItems();
        });
      },
  
      methods: {
        updateItems: function() {
          var vm = this;
          var items = get_items_RV();
          vm.$set(vm, 'items', items);
          
          vm.getProductsJSON();
        },
        
        getProductsJSON: function() {
          var vm = this;
          var p = vm.items.map(item => getProductJson(item.handle));        
          
          Promise.all(p)
          .then(response => {
            response.forEach((res_product, index) => {
              if (!res_product.handle) {
                // remove item from cache if product doesnt exist
                remove_item_RV(vm.items[index].handle);
                document.dispatchEvent(new CustomEvent('update:recently-viewed'));
              }
            })
            
            let products = response.filter(p => p.handle);
            vm.$set(vm, 'products', products);
          })
          .catch(error => console.error)
        }
      }    
    });
    
    return {vm_recently_vw_header, vm_recently_vw};
  })();